import { useMemo, useState } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import { formatDate } from '@/utils/date';
import { getDailyDashboardColumns } from '../components/DailyDashboardColumns';
import { useDailyDashboard } from './useDailyDashboard';

const EMPTY_FILTERS: Record<string, string> = {};

const route = getRouteApi('/_auth/attendance/');

export function useDailyDashboardPage() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const today = formatDate(new Date());
  const date = search.date ?? today;
  const isActive = search.isActive ?? true;

  const [searchText, setSearchText] = useState('');

  function setDate(next: string) {
    void navigate({ search: (previous) => ({ ...previous, date: next }), replace: true });
  }

  function setIsActive(next: boolean) {
    void navigate({ search: (previous) => ({ ...previous, isActive: next }), replace: true });
  }

  const { filtered, summary, isLoading, error, refetch } = useDailyDashboard(
    date,
    searchText,
    EMPTY_FILTERS,
    isActive,
  );

  const columns = useMemo(
    () => getDailyDashboardColumns({ searchText: searchText || undefined }),
    [searchText],
  );

  return {
    date,
    setDate,
    today,
    isActive,
    setIsActive,
    searchText,
    setSearchText,
    filtered,
    summary,
    columns,
    isLoading,
    error,
    refetch,
  };
}
